import { render } from "./SubscriptionReportsDetails.vue?vue&type=template&id=768db606"
import script from "./SubscriptionReportsDetails.vue?vue&type=script&lang=js"
export * from "./SubscriptionReportsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__